"use strict";
'kiwi public';

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/defineProperty"));
var _lodash = _interopRequireDefault(require("lodash"));
var Colours = _interopRequireWildcard(require("@/helpers/Colours"));
var TextFormatting = _interopRequireWildcard(require("@/helpers/TextFormatting"));
var _TransitionExpand = _interopRequireDefault(require("../utils/TransitionExpand.vue"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var _default = {
  components: {
    TransitionExpand: _TransitionExpand.default
  },
  props: ['ircinput'],
  data: function data() {
    return {
      fgColour: true,
      extColours: false
    };
  },
  computed: {
    sampleStyle: function sampleStyle() {
      var inputStyle = this.ircinput.style;
      var style = {};
      if (inputStyle.fgColour) {
        style.color = inputStyle.fgColour.hex;
      }
      if (inputStyle.bgColour) {
        style['background-color'] = inputStyle.bgColour.hex;
      }
      if (inputStyle.bold) {
        style['font-weight'] = 'bold';
      }
      if (inputStyle.italic) {
        style['font-style'] = 'italic';
      }
      var textDecoration = [];
      if (inputStyle.underline) {
        textDecoration.push('underline');
      }
      if (inputStyle.strikethrough) {
        textDecoration.push('line-through');
      }
      if (textDecoration.length) {
        style['text-decoration'] = textDecoration.join(' ');
      }
      return style;
    },
    bgColourDisabled: function bgColourDisabled() {
      return !this.ircinput.style.fgColour;
    },
    toggleColourTitle: function toggleColourTitle() {
      if (this.bgColourDisabled) {
        return TextFormatting.t('input_style_first');
      }
      var key = this.fgColour ? 'input_style_back' : 'input_style_fore';
      return TextFormatting.t(key);
    },
    extendedColourRange: function extendedColourRange() {
      return _lodash.default.range(16, 99);
    }
  },
  watch: {
    'ircinput.style.fgColour': function ircinputStyleFgColour(newColour) {
      if (!newColour) {
        this.fgColour = true;
        this.ircinput.setStyle({
          bgColour: null
        });
      }
    }
  },
  created: function created() {
    this.extColours = this.$state.setting('showColorPickerExtended');
  },
  methods: {
    toggleColour: function toggleColour() {
      if (this.bgColourDisabled) {
        return;
      }
      this.fgColour = !this.fgColour;
    },
    toggleStyle: function toggleStyle(key) {
      this.ircinput.setStyle((0, _defineProperty2.default)({}, key, !this.ircinput.style[key]));
    },
    toggleExtended: function toggleExtended() {
      this.extColours = !this.extColours;
    },
    onColourClick: function onColourClick(event) {
      var colour = window.getComputedStyle(event.target, null).getPropertyValue('background-color');
      // Convert rgb(x,x,x) to its hex form
      var m = colour.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      if (m) {
        var rgbObj = {
          r: parseInt(m[1], 10),
          g: parseInt(m[2], 10),
          b: parseInt(m[3], 10)
        };
        colour = Colours.rgb2hex(rgbObj);
      }
      var code = event.target.dataset.code;
      var styleKey = this.fgColour ? 'fgColour' : 'bgColour';
      this.ircinput.setStyle((0, _defineProperty2.default)({}, styleKey, {
        hex: colour,
        code: code
      }));
    }
  }
};
exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["inputtools"]) window._kiwi_exports["components"]["inputtools"] = {};
window._kiwi_exports["components"]["inputtools"]["TextStyle"]
window._kiwi_exports.components.inputtools.TextStyle = exports.default ? exports.default : exports;
